import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Button as BaseButton } from '@/components/atoms/Button';
import { Text } from '@/components/atoms/text';

export const Container = styled(Box)(({ theme }) => ({
  height: '100vh',
  display: 'flex',
  flexDirection: 'row',

  [theme.breakpoints.down('md')]: {
    display: 'block',
  },
}));

export const LogoContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export const Logo = styled('img')(() => ({
  width: '100%',
  maxWidth: '152px',
  height: 'auto',
}));

export const StyledImageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  backgroundColor: theme.palette['mint-green'][50],
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const Image = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  width: '100%',
  maxWidth: '540px',
  height: 'auto',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const StyledFormContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  flex: 1,
  padding: theme.spacing(3),
  overflowY: 'auto',
  height: '100vh',
  backgroundColor: theme.palette.mode === 'light' ? 'white' : theme.palette.background.default,

  [theme.breakpoints.down('md')]: {
    justifyContent: 'flex-start',
    padding: theme.spacing(5, 3),
    width: '100vw',
    textAlign: 'center',
  },
}));

export const FormContent = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  minWidth: '348px',
  maxWidth: '600px',
}));

export const FormsTitle = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export const Title = styled(Text)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(1),
  },
}));

export const Subtitle = styled(Text)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: '100%',
    maxWidth: '312px',
  },
}));

export const NewAccountOrAlreadyHaveAnAccount = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(0.6),
}));

export const SocialButtons = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const Button = styled(BaseButton)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1),
  fontSize: theme.typography.body1.fontSize,
  border: `1px solid ${theme.palette.action.disabled}`,
  color: theme.palette.text.primary,
  textTransform: 'none',
  ['img']: {
    maxWidth: '24px',
    height: 'auto',
    marginRight: theme.spacing(2),
  },
  ['& + button']: {
    marginTop: theme.spacing(3),
    backgroundColor: theme.palette.common.white,
  },
  ['&:hover']: {
    opacity: '0.85',
  },
}));

export const Icon = styled('img')(() => ({
  width: '24px',
  height: '24px',
}));

export const OrContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  margin: theme.spacing(2, 0),
}));

export const LanguageSelectorContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
